# +++++ Overlay Class +++++
class Overlay
    constructor: (el) ->
        @.$el = el
        @.$closeButton = @.$el.querySelector '.overlay__closer'
        @.openCloseInterval = undefined
        @.closeDelay = 410
        @.openDelay = 150
        @.closed = false
        @.pageLastScroll = 0

        @.InitEvents()
        @.AppendAndOpenOverlay()
        return

    InitEvents: ->
        self = @
        @.$closeButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.CloseOverlay()
            return
        window.addEventListener 'closealloverlays', (e) ->
            self.CloseOverlay true
            return
        return
    
    AppendAndOpenOverlay: ->
        # save page last scroll position and fix page
        @.pageLastScroll = window.scrollY
        document.getElementById('site').classList.add 'overlay-open'
        document.getElementById('content').style.transform = "translateY(-" + @.pageLastScroll + "px)"

        # append overlay
        document.getElementById('site').appendChild @.$el
        # shift other tabindex
        window.appUtils.UnsetTabIndex document.querySelectorAll('#site [tabindex]:not(.overlay *)'), true

        window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
        window.clearInterval @.openCloseInterval
        self = @
        @.openCloseInterval = window.setInterval () ->
            window.clearInterval self.openCloseInterval
            self.$el.classList.add 'overlay--open'
            return
        , @.openDelay
        return
    
    CloseOverlay: (forced) ->
        if !@.closed
            # set closed
            @.closed = true

            # close overlay and remove element
            @.$el.classList.remove 'overlay--open'
            # reset page scroll
            document.getElementById('site').classList.remove 'overlay-open'
            document.getElementById('content').style.removeProperty "transform"
            window.scrollTo 0, @.pageLastScroll
            # wait for overlay close animation and remove it afterwards
            window.clearInterval @.openCloseInterval
            self = @
            @.openCloseInterval = window.setInterval () ->
                window.clearInterval self.openCloseInterval
                self.$el.remove()
                return
            , @.closeDelay

            # unshift tabindex
            window.appUtils.ResetTabIndex document.getElementById('site')
            
            # delete overlay/offers param
            window.appUtils.DeleteUrlParam 'overlay', true
            window.appUtils.DeleteUrlParam 'offer', true

            # check if close comes not forced e.g. by closealloverlays event -> prevent call stack overflow
            if !forced
                window.dispatchEvent new CustomEvent 'overlayobserverrefresh', { bubbles: true }
        return
            

# +++++ Overlay Observer Class +++++
class OverlayObserver
    constructor: () ->
        @.params = window.appUtils.GetUrlParams()

        @.InitEvents()
        @.CheckForOverlayParams()
        return

    InitEvents: ->
        self = @
        window.addEventListener 'popstate', (e) ->
            self.RefreshParams()
            return
        window.addEventListener 'overlayobserverrefresh', (e) ->
            self.RefreshParams()
            return
        return

    CheckForOverlayParams: ->
        closeAllOverlays = true
        if @.params
            if @.params.hasOwnProperty('overlay')
                if @.params.offer != ""
                    closeAllOverlays = false
                    @.LoadOverlay @.params.overlay
            if @.params.hasOwnProperty('offer')
                if @.params.overlay != ""
                    closeAllOverlays = true
                    @.LoadOverlay @.params.offer, false, true
        if closeAllOverlays
            window.dispatchEvent new CustomEvent 'closealloverlays', { bubbles: true }
        return

    LoadOverlay: (overlayOrOfferId, pushState, isOffer) ->
        window.dispatchEvent new CustomEvent 'showpageloader', { bubbles: true }
        self = @
        requestUrl = if isOffer then "#{window.location.protocol}//#{window.location.host}/api/offerdetail/#{overlayOrOfferId}" else "#{window.location.protocol}//#{window.location.host}/overlay/#{overlayOrOfferId}"
        request = window.appUtils.XMLHttpRequest(
            "GET",
            requestUrl,
            () ->
                window.dispatchEvent new CustomEvent 'hidepageloader', { bubbles: true }
                if request.responseText && request.responseText != ""

                    overlay = window.appUtils.StringToHtml request.responseText
                    new Overlay(overlay)
                    # if overlay load command comes via overlay--opener link
                    if pushState
                        self.PushState overlayOrOfferId, isOffer

            () ->
                window.dispatchEvent new CustomEvent 'hidepageloader', { bubbles: true }
                console.log "Es ist ein Fehler aufgetreten. Fehler-Code: " + request.status
        )
        return

    PushState: (overlayOrOfferId, isOffer) ->
        if isOffer
            window.appUtils.PushState 'offer', overlayOrOfferId
        else
            window.appUtils.PushState 'overlay', overlayOrOfferId
        return
    
    RefreshParams: ->
        @.params = window.appUtils.GetUrlParams()
        @.CheckForOverlayParams()
        return
 
window.rsmOverlayObserver = new OverlayObserver()

# +++++ Overlay Opener Class +++++
class OverlayOpener
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'overlay--opener-bound'
            @.offerId = @.$el.dataset?.offerId ? false
            @.overlayId = @.$el.dataset?.overlayId ? false

            @.$el.classList.add 'overlay--opener-bound'
            @.InitEvents()
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'click', (e) ->
            e.preventDefault()
            @.blur()
            if self.offerId
                window.rsmOverlayObserver.LoadOverlay self.offerId, true, true
            if self.overlayId
                window.rsmOverlayObserver.LoadOverlay self.overlayId, true, false
            return
        return

BindOverlayOpener = ->
    document.querySelectorAll '.overlay--opener:not(.overlay--opener-bound)'
        .forEach (el) ->
            new OverlayOpener el
            return
    return

window.addEventListener 'bind-components', BindOverlayOpener
